import dataServices from '@/shared/api/dataServices';

// import {
//   EMAIL_VALIDATION,
//   OTP_VALIDATION
// } from '../mutation-types';

const state = () => ({
});

const mutations = {};

const actions = {
  async emailValidationAction(store, data) {
    const response = await dataServices.validateEmail(data);
    return response;
    // console.log(data);
  },
  async otpValidationAction(store, data) {
    const response = await dataServices.validateOtp(data);
    return response;
  }
};

const getters = {
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
